// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { MetalFilterMetalFragmentDoc } from '../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
export const MetalVariationFragmentDoc = gql`
    fragment metalVariation on CatalogueProduct {
  primaryMetal {
    ...metalFilterMetal
  }
}
    ${MetalFilterMetalFragmentDoc}`;